/**
 * Shared class strings for the `Command`-based search field used by
 * `TopicSwitcher` (`/terapija`, `/terapeuti`) and the help center search
 * (`/podrska`), so the two never drift into two different-looking search
 * fields again.
 */
export const SEARCH_FIELD_WRAPPER_CLASS =
  "h-10 rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-within:outline-hidden focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2";

export const SEARCH_FIELD_INPUT_CLASS = "h-full py-0 text-base md:text-sm";

export const SEARCH_FIELD_DROPDOWN_CLASS =
  "absolute left-0 right-0 top-full z-20 mt-2 max-h-[360px] overflow-y-auto rounded-xl border border-border bg-background shadow-lg";
